import React from 'react';
import { format } from 'date-fns';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { AlertBodyProps } from './AlertBodyProps';
import AlertTitle from '@components/Alerts/presentationComponents/AlertTitle';
import AlertUser from '@components/Alerts/presentationComponents/AlertUser';
import AlertDate from '@components/Alerts/presentationComponents/AlertDate';
import { AlertDisplayField } from '@components/Alerts/AlertDisplayField/AlertDisplayField';
import AlertDetails from '@components/Alerts/presentationComponents/AlertDetails';

const useStyles = makeStyles((theme) => createStyles({
	body: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
	},
	title: {
		paddingLeft: theme.spacing(0),
	},
	topSection: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%',
	},
}));

export const AlertBody = ({
	alertUser,
	alertTime,
	alertMessage,
	body,
	links,
}: AlertBodyProps) => {
	const classes = useStyles();
	const parsedDateCreated = alertTime ? new Date(alertTime) : null;
	const dateCreatedDisplay = parsedDateCreated
		? format(parsedDateCreated, 'h:mm a MMM d')
		: '';

	return (
		<AlertDetails>
			<Box className={classes.topSection}>
				<Box>
					{(alertUser || alertTime) &&
						<AlertTitle
							className={classes.title}
							data-testid="alertBody-alertTitle"
						>
							<AlertUser>
								{alertUser}
							</AlertUser>
							<AlertDate>
								{dateCreatedDisplay}
							</AlertDate>
						</AlertTitle>
					}
					{alertMessage &&
						<AlertDisplayField data-testid="alertBody-alertDisplayField-message">
							{alertMessage}
						</AlertDisplayField>
					}
				</Box>
				{links && (
					<Box>
						{links}
					</Box>
				)}
			</Box>
			<Box className={classes.body}>
				{body}
			</Box>
		</AlertDetails>
	);
};
